/* eslint-disable  promise/prefer-await-to-callbacks */
import { useIntersection } from './useIntersection';
/**
 * this hook helps to perform actions such as using a callback when the target
 * element is intersecting the view
 *
 * @callback callback
 * @returns func
 */
export function useImpressionCallback(callback) {
    const [isInViewport, setTargetElement] = useIntersection({
        threshold: 0.5,
        triggerOnce: true,
    });
    if (isInViewport) {
        callback();
    }
    return setTargetElement;
}
